export const PAYMENT_MODE = {
    BANK_PAYMENT: 'Bank Payment',
    WIRE_TRANSFER: 'Wire Transfer',
    MAIL_CHEQUE: 'Mail Cheque',
};

// hard-coding only the display label as 'CHECK' since that's what is prominent in US - not worth it at this point to
// change the enums since this could involve db back-data changes, ext backend, icp-core backend, etc.
export const getPaymentModeDisplay = (paymentMode) => {
    if (paymentMode === PAYMENT_MODE.MAIL_CHEQUE) {
        return 'MAIL CHECK';
    }
    return paymentMode;
};

export const INVOICE_LINK_STATUS = {
    VALID: 'VALID',
    INVALID: 'INVALID',
    SUBMITTED: 'SUBMITTED',
    EXPIRED: 'EXPIRED',
};

export const PAYMENT_MODE_OPTIONS = {
    [PAYMENT_MODE.BANK_PAYMENT]: {
        label: getPaymentModeDisplay(PAYMENT_MODE.BANK_PAYMENT),
        value: PAYMENT_MODE.BANK_PAYMENT,
        key: PAYMENT_MODE.BANK_PAYMENT,
    },
    [PAYMENT_MODE.WIRE_TRANSFER]: {
        label: getPaymentModeDisplay(PAYMENT_MODE.WIRE_TRANSFER),
        value: PAYMENT_MODE.WIRE_TRANSFER,
        key: PAYMENT_MODE.WIRE_TRANSFER,
    },
    [PAYMENT_MODE.MAIL_CHEQUE]: {
        label: getPaymentModeDisplay(PAYMENT_MODE.MAIL_CHEQUE),
        value: PAYMENT_MODE.MAIL_CHEQUE,
        key: PAYMENT_MODE.MAIL_CHEQUE,
    },
};

export const ConsultantInvoicePaymentStatus = {
    UNDER_REVIEW: 'Under Review',
    DETAILS_VERIFIED: 'Details Verified',
    PAYMENT_INITIATED: 'Payment Initiated',
    PAYMENT_SUCCESSFUL: 'Payment Successful',
    PAYMENT_FAILED: 'Payment Failed',
};

export const INVOICE_TRACKING_CORRECTION_DAYS = 2;

export const INVOICE_TRACKING_PAYOUT_DAYS = 21;

export const InvoicingPaymentSuccessAdjustedLabel = {
    [PAYMENT_MODE.MAIL_CHEQUE]: 'Check Dispatched',
};
